import React, { useEffect, useState, useRef } from "react";

import { TableComponent } from "../HomeModule/CustomAPIs/components/TableComponent";
import { CreateContact } from "./New_contact";
import { EditContact } from "./Edit_contact";
import { DeleteContact } from "./Delete_contact";

import { Heading } from "V2.0/common/heading";
import {
  IdentificationIcon,
  PencilIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import Pagination from "V2.0/components/Pagination";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { useDebouncedSearch } from "V2.0/HomePages/Threads/models/useDebouncedSearch";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { formatTime } from "V2.0/utils";

export function Contact(props) {
  const { contacts, fetchContacts, projectId, isViewOnly } = props;
  const [action, setAction] = useState({
    actionMode: "",
    isOpen: "",
    actionItem: "",
  });
  const searchElementRef = useRef(null);
  const { searchTerm, updateSearchTerm } = useDebouncedSearch();

  useEffect(
    function () {
      fetchContacts(projectId, 1, 50, true, searchTerm);
    },
    [searchTerm],
  );

  const onEdit = (contact) => {
    setAction({
      actionMode: "edit",
      isOpen: true,
      actionItem: contact,
    });
  };

  const onDelete = (contact) => {
    setAction({
      actionMode: "delete",
      isOpen: true,
      actionItem: contact,
    });
  };

  const onClose = () => {
    setAction({
      actionMode: "",
      isOpen: false,
      actionItem: "",
    });
  };
  const isContactsEmpty = contacts.contacts.length === 0 && !searchTerm;

  return (
    <>
      <div className="flex h-full max-w-7xl mx-auto py-4">
        <div className="w-full h-full flex flex-col gap-y-8">
          <div className="flex justify-between p-4 items-center">
            <div className="flex gap-x-2 items-center">
              <Heading>Contacts</Heading>
            </div>
            {!isViewOnly && (
              <CreateContact
                fetchContacts={fetchContacts}
                projectId={projectId}
              />
            )}
          </div>

          <div>
            <div className="w-80">
              <input
                ref={searchElementRef}
                type="search"
                onChange={(e) => {
                  const term = e.target.value;
                  updateSearchTerm(term);
                }}
                placeholder="Search by Phone Number or Email"
                className="w-full rounded border border-gray-300 px-4 py-2 text-sm text-gray-600 placeholder-gray-400 focus:outline-none focus:border-none focus:ring-1 focus:ring-blue-500"
              />
            </div>
          </div>

          {isContactsEmpty ? (
            contacts.isLoading ? (
              <div className="h-96 w-full border border-gray-200 rounded-lg">
                <div className="h-full w-full flex justify-center items-center">
                  <div className="flex flex-col gap-y-4 items-center">
                    <div className="flex flex-col items-center gap-y-2">
                      <AiOutlineLoading3Quarters className="animate-spin" />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="h-96 w-full border border-gray-200 rounded-lg">
                <div className="h-full w-full flex justify-center items-center">
                  <div className="flex flex-col gap-y-4 items-center">
                    <IdentificationIcon className="size-10 text-gray-500" />
                    <div className="flex flex-col items-center gap-y-2">
                      <p className="text-base font-semibold text-gray-900">
                        Contacts
                      </p>
                      <div className="w-80 text-sm text-gray-700">
                        Contacts section allows you to manage and store all your
                        customer information in one place, including phone
                        numbers, emails.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          ) : (
            <div className="flex flex-col gap-y-2 h-full w-full min-h-0">
              <div className="flex-1 h-full min-h-0 overflow-scroll">
                <Table>
                  <TableHead>
                    <TableHeader>First Name</TableHeader>
                    <TableHeader>Last Name</TableHeader>
                    <TableHeader>Phone Number</TableHeader>
                    <TableHeader>Email</TableHeader>
                    <TableHeader>Created At</TableHeader>
                    <TableHeader>Action</TableHeader>
                  </TableHead>
                  <TableBody>
                    {contacts.contacts.map((contact, idx) => {
                      return (
                        <TableRow>
                          <TableCell>{contact.firstName}</TableCell>
                          <TableCell>{contact.lastName}</TableCell>
                          <TableCell>
                            <div className="max-w-[200px]">{contact.phone}</div>
                          </TableCell>
                          <TableCell>{contact.email}</TableCell>
                          <TableCell>{formatTime(contact.createdAt)}</TableCell>
                          <TableCell>
                            {!isViewOnly && (
                              <div className="flex items-center gap-x-2">
                                <Button
                                  outline
                                  onClick={() => onEdit(contact)}
                                >
                                  <PencilIcon />
                                </Button>
                                <Button
                                  outline
                                  onClick={() => onDelete(contact)}
                                >
                                  <TrashIcon />
                                </Button>
                              </div>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </div>
              <div className="relative bottom-0">
                <Pagination
                  currentPage={contacts.currentPage}
                  totalItems={contacts.totalContacts}
                  itemsPerPage={contacts.pageSize}
                  onPageChange={(page) => {
                    fetchContacts(projectId, page, 50, false);
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      {action.actionMode === "edit" && (
        <EditContact
          open={action.isOpen}
          contact={action.actionItem}
          onClose={onClose}
          fetchContacts={() => fetchContacts(projectId, 1, 50, false)}
          projectId={projectId}
        />
      )}
      {action.actionMode === "delete" && (
        <DeleteContact
          open={action.isOpen}
          contact={action.actionItem}
          onClose={onClose}
          fetchContacts={() => fetchContacts(projectId, 1, 50, false)}
          projectId={projectId}
        />
      )}
    </>
  );
}
